// extracted by mini-css-extract-plugin
export default {"container":"ScoreBoard_container__phbSb","padding":"ScoreBoard_padding__KXV8E"};